"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.login = void 0;
const msal_1 = require("./msal");
async function login() {
    try {
        await msal_1.msalInstance.loginRedirect(msal_1.iffLoginRequest);
    }
    catch (error) {
        return error;
    }
}
exports.login = login;
